import { AuthApi, UserApi } from 'generated/apiUsers';
import { Configuration } from 'generated/configuration';
import { getLoggedinUser } from 'helpers/api_helper';

const { REACT_APP_API_URL } = process.env;

export const updateUser = async (data: any) => {
                
  const authUser: any = getLoggedinUser()
  const api = new UserApi(new Configuration({
      accessToken: authUser.accessToken || '',
      basePath: `${REACT_APP_API_URL}`,
  }));
  return api.userControllerUpdate(authUser.uid, data);
}

export const changePassword = async (data: any) => {
                
  const authUser: any = getLoggedinUser()
  const api = new UserApi(new Configuration({
      accessToken: authUser.accessToken || '',
      basePath: `${REACT_APP_API_URL}`,
  }));
  return api.userControllerChangePassword({ id: authUser.uid, ...data});
}

export const createUser = async (data: any) => {
  const authUser: any = getLoggedinUser();
  const api = new AuthApi(
    new Configuration({
      accessToken: authUser.accessToken || "",
      basePath: `${REACT_APP_API_URL}`,
    })
  );
  return api.authControllerRegister({ ...data, managerId: authUser.uid, mainRoleId: data.mainRole.value });
};

export const deleteUser = async (uuid: string) => {
  const authUser: any = getLoggedinUser();
  const api = new UserApi(
    new Configuration({
      accessToken: authUser.accessToken || "",
      basePath: `${REACT_APP_API_URL}`,
    })
  );
  return api.userControllerDelete(uuid);
};
